{
  "declineButton": "Déclin",
  "iAgree": "Je suis d'accord",
  "linkTo": "Voir les conditions d'utilisation",
  "title": "Conditions d'utilisation"
}
